import { render } from "./UnpackingList.vue?vue&type=template&id=77a3db2a&scoped=true&ts=true&lang=pug"
import script from "./UnpackingList.vue?vue&type=script&lang=ts"
export * from "./UnpackingList.vue?vue&type=script&lang=ts"

import "./UnpackingList.vue?vue&type=style&index=0&id=77a3db2a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a3db2a"]])

export default __exports__